"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var global_1 = require("../../base/global");
var layer_1 = tslib_1.__importDefault(require("../bar/layer"));
var label_1 = tslib_1.__importDefault(require("./component/label"));
var animation_1 = require("./animation");
var RangeBarLayer = /** @class */ (function (_super) {
    tslib_1.__extends(RangeBarLayer, _super);
    function RangeBarLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'rangeBar';
        return _this;
    }
    RangeBarLayer.getDefaultOptions = function () {
        return _.deepMix(_super.getDefaultOptions.call(this), {
            label: {
                visible: true,
                position: 'outer',
            },
            xAxis: {
                visible: true,
                autoHideLabel: false,
                autoRotateLabel: false,
                autoRotateTitle: false,
                grid: {
                    visible: true,
                },
                line: {
                    visible: false,
                },
                tickLine: {
                    visible: false,
                },
                label: {
                    visible: true,
                },
                title: {
                    visible: true,
                    offset: 12,
                },
            },
            yAxis: {
                visible: true,
                autoHideLabel: false,
                autoRotateLabel: false,
                autoRotateTitle: true,
                grid: {
                    visible: false,
                },
                line: {
                    visible: true,
                },
                tickLine: {
                    visible: true,
                },
                label: {
                    visible: true,
                },
                title: {
                    visible: false,
                    offset: 12,
                },
            },
        }, {});
    };
    RangeBarLayer.prototype.afterRender = function () {
        if (this.options.label && this.options.label.visible) {
            var label = new label_1.default(tslib_1.__assign({ view: this.view, plot: this }, this.options.label));
            label.render();
        }
        // 为更新动画缓存shape
        var shapeCaches = [];
        var geoms = this.view.get('elements');
        _.each(geoms, function (geom) {
            var shapes = geom.getShapes();
            _.each(shapes, function (shape) {
                shapeCaches.push(shape);
            });
        });
        animation_1.setShapeCache(shapeCaches);
        _super.prototype.afterRender.call(this);
    };
    RangeBarLayer.prototype.extractLabel = function () { };
    RangeBarLayer.prototype.animation = function () {
        _super.prototype.animation.call(this);
        this.bar.animate = {
            appear: {
                animation: 'clipInFromCenter',
                duration: 600,
            },
            update: {
                animation: 'updateFromCenter',
                duration: 600,
            },
        };
    };
    return RangeBarLayer;
}(layer_1.default));
exports.default = RangeBarLayer;
global_1.registerPlotType('rangeBar', RangeBarLayer);
//# sourceMappingURL=layer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/range-bar/layer.js
// module id = 957
// module chunks = 37